import React from 'react';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import TextBlockContent from 'components/ModularBlocks/TextBlock/TextBlockContent';

import { TextBlockI } from 'interfaces/content-stack/modular-blocks/textBlock';

export interface TextBlockProps {
  className: string;
  data: TextBlockI & {
    reference: TextBlockI[];
  };
}

function TextBlock({ data, className }: TextBlockProps) {
  const { reference } = data;

  return (
    <ContentContainer className={className}>
      <TextBlockContent data={reference?.[0] || data} />
    </ContentContainer>
  );
}

export default React.memo(TextBlock);
